export const RECENT_OBJECTS_RESOURCE_PATH = '/v1/objekt/entities';
export const SCAN_OBJECT_RESOURCE_PATH = '/v1/objekt/scan/{{type}}/{{id}}';
export const SCAN_GET_OBJECT_RESOURCE_PATH =
  '/v1/bean/abfrageResult/objekt/{{id}}';
export const GET_OBJECT_BY_ID_RESOURCE_PATH = '/v1/objekt/entities/{{id}}';
